"use client";

import { handleParse } from "@/lib/handleParse";
import { removeLeadingHashNumber } from "@/lib/utils";
import { FeaturedImageNode } from "@/types/page";
import Image from "next/image";
import React from "react";

export default function Hero({
  img,
  description,
  title,
}: {
  img: FeaturedImageNode | undefined;
  description: string | undefined | null;
  title: string | undefined | null;
}) {
  const heading = title && removeLeadingHashNumber(title);
  return (
    <div className="relative w-full md:h-[565px] h-[465px] contain">
      {img?.mediaItemUrl && img?.altText && (
        <Image
          src={img.mediaItemUrl}
          alt={img.altText}
          fill
          priority
          style={{ objectFit: "cover" }}
        />
      )}
      <div className="absolute w-full z-20 top-[65px] h-[calc(100%-65px)] bg-transparent layout md:grid md:grid-cols-2 font-josefin text-white flex flex-col justify-center items-center">
        <div className="flex flex-col justify-center">
          <h1 className="text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl font-bold font-josefin uppercase">
            {heading}
          </h1>
          {description && handleParse(description)}
        </div>
        <div></div>
      </div>
      <div className="absolute z-10 inset-0 bg-overlay hidden md:block"></div>
      <div className="absolute z-10 inset-0 bg-black/40 block md:hidden"></div>
    </div>
  );
}
